@if (userFormEnable) {
  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12 pl-1">
              <div class="form-group">
                <label>Current Password<span class="text-danger">*</span></label>
                <input formControlName="currentPassword" type="password" class="form-control"
                  placeholder="Current Password"
                  [ngClass]="{'is-invalid': changePasswordForm.controls.currentPassword.touched && changePasswordForm.controls.currentPassword?.errors}">
                @if (changePasswordForm.controls.currentPassword.touched && changePasswordForm.controls.currentPassword?.errors?.required) {
                  <div
                    class="invalid-feedback d-block">
                    Please enter Current Password.
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 pl-1">
              <div class="form-group">
                <label>New Password<span class="text-danger">*</span></label>
                <input formControlName="newPassword" type="password" class="form-control"
                  placeholder="New Password"
                  [ngClass]="{'is-invalid': changePasswordForm.controls.newPassword.touched && changePasswordForm.controls.newPassword?.errors}">
                @if (changePasswordForm.controls.newPassword.touched) {
                  <div
                    class="invalid-feedback d-block">
                    @if (changePasswordForm.controls.newPassword?.errors?.required) {
                      Please enter New Password.
                    }
                    @if (changePasswordForm.controls.newPassword?.errors?.minlength) {
                      Please enter minimum
                      {{ changePasswordForm.controls.newPassword?.errors?.requiredLength }}
                      characters.
                    }
                    @if (changePasswordForm.controls.newPassword?.errors?.maxlength) {
                      Max
                      {{ changePasswordForm.controls.newPassword?.errors?.maxlength?.requiredLength }}
                      characters
                      allowed.
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 pl-1">
              <div class="form-group">
                <label>New Confirm Password<span class="text-danger">*</span></label>
                <input formControlName="newConfirmPassword" type="password" class="form-control"
                  placeholder="New Confirm Password"
                  [ngClass]="{'is-invalid': changePasswordForm.controls.newConfirmPassword.touched && changePasswordForm.controls.newConfirmPassword?.errors}">
                @if (changePasswordForm.controls.newConfirmPassword.touched) {
                  <div
                    class="invalid-feedback d-block">
                    @if (changePasswordForm.controls.newConfirmPassword?.errors?.required) {
                      Please enter New Password.
                    }
                    @if (changePasswordForm.controls.newConfirmPassword?.errors?.minlength) {
                      Please enter minimum
                      {{ changePasswordForm.controls.newConfirmPassword?.errors?.requiredLength }}
                      characters.
                    }
                    @if (changePasswordForm.controls.newConfirmPassword?.errors?.maxlength) {
                      Max
                      {{ changePasswordForm.controls.newConfirmPassword?.errors?.maxlength?.requiredLength
                      }}
                      characters
                      allowed.
                    }
                    @if (changePasswordForm.controls.newConfirmPassword?.errors?.passwordNotMatch) {
                      Please enter identical password.
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer modal-footer--sticky">
      <div>
        <button class="btn btn-outline-default mr-2 btn-round" (click)="resetForm()">Reset</button>
        <button type="submit" class="btn btn-primary btn-round" >Save</button>
      </div>
    </div>
  </form>
}